const fallbackMode = process.env.NODE_ENV === 'development' ? 'mock' : 'live';

const rawMode = (process.env.REACT_APP_API_MODE ?? fallbackMode).toLowerCase();

export const API_MODE = rawMode === 'live' ? 'live' : 'mock';

export const isMockApiMode = API_MODE === 'mock';
